import { render, staticRenderFns } from "./IntercomBottomBar.vue?vue&type=template&id=9be43fe8&scoped=true"
import script from "./IntercomBottomBar.vue?vue&type=script&lang=js"
export * from "./IntercomBottomBar.vue?vue&type=script&lang=js"
import style0 from "./IntercomBottomBar.vue?vue&type=style&index=0&id=9be43fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be43fe8",
  null
  
)

export default component.exports